import { Icon, Tooltip } from "antd";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import OptionsBox from "../OptionsBox";

import "./Navbar.scss";

import { ReactComponent as AddSvg } from "../../assets/icon/ic_add_24dp.svg";
import { ReactComponent as CloseSvg } from "../../assets/icon/ic_close_24dp.svg";
import { ReactComponent as SettingsSvg } from "../../assets/icon/ic_settings_24dp.svg";

function GetNavbarButtons({
  settingsOpen,
  openMessageBox,
  toggleMoreOptions,
  onOptionsClickAway,
  isIconActive,
  toggleOptionsBox,
  optionsBoxOpen,
  optionBoxDirection,
  collapsed,
  isMinimalist,
}) {
  if (isMinimalist && collapsed) {
    return false;
  }

  if (settingsOpen) {
    return (
      <div className="header-buttons">
        <Tooltip
          title={<FormattedMessage id="tooltip.close" />}
          overlayClassName="social-tooltip"
        >
          <Icon
            className="action-button"
            component={CloseSvg}
            onClick={(e) => {
              e.stopPropagation();
              toggleMoreOptions();
            }}
          />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="header-buttons">
      <Tooltip
        title={<FormattedMessage id="tooltip.newChat" />}
        overlayClassName="social-tooltip"
      >
        <Icon
          className="action-button"
          component={AddSvg}
          onClick={openMessageBox}
        />
      </Tooltip>

      <Tooltip
        title={<FormattedMessage id="tooltip.moreActions" />}
        overlayClassName="social-tooltip"
      >
        <Icon
          className={"action-button " + isIconActive}
          component={SettingsSvg}
          onClick={toggleOptionsBox}
        />
      </Tooltip>

      {optionsBoxOpen && (
        <OptionsBox
          onClickAway={onOptionsClickAway}
          toggleMoreOptions={toggleMoreOptions}
          direction={optionBoxDirection}
        />
      )}

      <Tooltip
        title={<FormattedMessage id="tooltip.close" />}
        overlayClassName="social-tooltip"
      >
        <Icon
          className="action-button"
          component={CloseSvg}
          onClick={collapsed}
        />
      </Tooltip>
    </div>
  );
}

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      optionsBoxOpen: false,
      optionBoxDirection: "bottom",
    };

    this.onOptionsClickAway = this.onOptionsClickAway.bind(this);
  }

  onOptionsClickAway() {
    this.setState({
      optionsBoxOpen: false,
    });
  }

  openMessageBox(e) {
    e.stopPropagation();

    this.props.openMessageBox({
      newChat: true,
    });
  }

  toggleOptionsBox(e) {
    e.stopPropagation();

    this.props.loadedConfigurations &&
      this.setState({
        optionsBoxOpen: !this.state.optionsBoxOpen,
        optionBoxDirection: this.props.parentCollapsed ? "top" : "bottom",
      });
  }

  isIconActive() {
    return this.state.optionsBoxOpen ? "active" : "";
  }

  getTitleClasses() {
    return this.props.status ? "title" : "title title-only";
  }

  toggleMoreOptions() {
    this.setState(
      {
        optionsBoxOpen: false,
      },
      this.props.toggleMoreOptions()
    );
  }

  render() {
    const themeConfig = window.Social.getThemeConfig();

    const {
      notify,
      parentCollapsed,
      settingsOpen,
      onNavbarClick,
      title,
      status,
    } = this.props;

    const minimalistTheme =
      themeConfig && themeConfig.minimalist ? "minimalist" : "";

    return (
      <div
        className={`navbar ${notify ? "notify" : ""} ${minimalistTheme} ${
          parentCollapsed ? "collapsed" : ""
        }`}
        onClick={onNavbarClick}
      >
        <div className="header">
          {themeConfig && themeConfig.minimalist && parentCollapsed && (
            <div className="add-chat-container">
              <Tooltip
                title={<FormattedMessage id="tooltip.newChat" />}
                overlayClassName="social-tooltip"
              >
                <Icon
                  className="action-button-square add-chat"
                  component={AddSvg}
                  onClick={this.openMessageBox.bind(this)}
                />
              </Tooltip>
            </div>
          )}

          <div className="header-title">
            <span className={this.getTitleClasses()}>{title}</span>
            {status && <span className="status">{status}</span>}
          </div>

          <GetNavbarButtons
            collapsed={parentCollapsed}
            settingsOpen={settingsOpen}
            isMinimalist={themeConfig && themeConfig.minimalist}
            openMessageBox={this.openMessageBox.bind(this)}
            toggleMoreOptions={this.toggleMoreOptions.bind(this)}
            onOptionsClickAway={this.onOptionsClickAway}
            isIconActive={this.isIconActive()}
            toggleOptionsBox={this.toggleOptionsBox.bind(this)}
            optionsBoxOpen={this.state.optionsBoxOpen}
            loadedConfigurations={this.state.loadedConfigurations}
            optionBoxDirection={this.state.optionBoxDirection}
          />
        </div>
      </div>
    );
  }
}

export default Navbar;
